import { prefix } from '@fortawesome/free-solid-svg-icons';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  booking: {},
  dataMovite: {
    motive: {},
    prefixTime: '',
    time: '',
  },
};

const bookingSlice = createSlice({
  name: 'booking',
  initialState,
  reducers: {
    setBooking(state, { payload }) {
      state.booking = payload;
    },
    setDataMotive(state, { payload }) {
      state.dataMovite = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase('RESET_BOOKING_STATE', () => initialState);
  },
});

export const {
  setBooking,
  setDataMotive,
} = bookingSlice.actions;
export default bookingSlice.reducer;
